/**
 * Created by staffanrantzow on 12/04/16.
 */

/* @flow */
import React from 'react';
import Translate from 'react-translate-component';
import Raven from 'raven-js';

export class GeneralError extends React.Component {

  render () {
    Raven.captureMessage('General Error');
    return (<p className='error'><Translate content='GENERAL_ERROR'/></p>);
  }
}

export default GeneralError;




/** WEBPACK FOOTER **
 ** ./src/components/general-error/general-error.js
 **/